/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SykedIntegrationRefreshPost$Params {
  token?: string;
}

export function sykedIntegrationRefreshPost(http: HttpClient, rootUrl: string, params?: SykedIntegrationRefreshPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sykedIntegrationRefreshPost.PATH, 'post');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VitalScoreStrictHttpResponse<void>;
    })
  );
}

sykedIntegrationRefreshPost.PATH = '/SykedIntegration/Refresh';
